var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVanuatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 16.2717C31.9999 15.5644 31.9535 14.8679 31.8645 14.1848H13.9128C10.644 10.9162 4.68599 4.95851 4.68624 4.95801C-1.56212 11.2064 -1.56212 21.337 4.68624 27.5855L13.913 18.3587H31.8645C31.9534 17.6755 31.9999 16.979 31.9999 16.2717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9957 16.6357C31.995 16.6666 31.9943 16.6976 31.9934 16.7285C31.9942 16.6975 31.9949 16.6666 31.9957 16.6357Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9798 17.0728C31.9784 17.1033 31.9762 17.1338 31.9746 17.1643C31.9762 17.1338 31.9782 17.1033 31.9798 17.0728Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9592 17.4214C31.956 17.4663 31.9528 17.5113 31.9492 17.5561C31.9528 17.5113 31.9559 17.4663 31.9592 17.4214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9053 14.5278C31.9111 14.5813 31.917 14.6348 31.9223 14.6884C31.917 14.6347 31.9111 14.5813 31.9053 14.5278Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9746 15.3789C31.9763 15.4094 31.9784 15.4398 31.9798 15.4704C31.9783 15.4398 31.9763 15.4093 31.9746 15.3789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9933 15.8149C31.9942 15.8458 31.9948 15.8768 31.9956 15.9077C31.9949 15.8767 31.9942 15.8458 31.9933 15.8149Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9492 14.9873C31.9528 15.0321 31.956 15.0771 31.9592 15.122C31.9559 15.0771 31.9528 15.0321 31.9492 14.9873Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8649 14.1845C31.8721 14.2393 31.8785 14.2944 31.885 14.3493C30.9354 6.41922 24.1863 0.271484 16.0004 0.271484C11.582 0.271484 7.58196 2.06242 4.68652 4.95798L13.913 14.1845H31.8649V14.1845Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8649 18.3582H13.913L4.68652 27.5848C7.58196 30.4803 11.582 32.2713 16.0004 32.2713C24.1863 32.2713 30.9355 26.1235 31.885 18.1934C31.8785 18.2483 31.872 18.3034 31.8649 18.3582Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9223 17.8545C31.917 17.9081 31.9111 17.9616 31.9053 18.0151C31.9111 17.9616 31.9171 17.9082 31.9223 17.8545Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.958 15.1216C31.9641 15.2071 31.9696 15.2929 31.9743 15.3788C31.9695 15.2929 31.9641 15.2071 31.958 15.1216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8846 14.3496C31.8918 14.4089 31.8986 14.4684 31.905 14.5279C31.8985 14.4684 31.8917 14.409 31.8846 14.3496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.922 14.688C31.9317 14.7873 31.9406 14.8869 31.9485 14.9868C31.9406 14.8869 31.9318 14.7872 31.922 14.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 16.2715C31.9997 16.3932 31.9978 16.5144 31.9951 16.6353C31.9978 16.5143 31.9997 16.3931 31.9997 16.2715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9752 17.1641C31.9705 17.25 31.965 17.3357 31.959 17.4213C31.965 17.3357 31.9704 17.25 31.9752 17.1641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9485 17.5562C31.9406 17.656 31.9317 17.7556 31.922 17.8548C31.9318 17.7556 31.9406 17.656 31.9485 17.5562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.905 18.0151C31.8986 18.0746 31.8918 18.134 31.8846 18.1934C31.8917 18.1341 31.8985 18.0746 31.905 18.0151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9951 15.9077C31.9978 16.0287 31.9997 16.15 31.9997 16.2715C31.9997 16.15 31.9978 16.0287 31.9951 15.9077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9805 15.4702C31.9861 15.5847 31.9903 15.6997 31.9936 15.8148C31.9903 15.6996 31.9862 15.5847 31.9805 15.4702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9926 16.728C31.9894 16.8432 31.9851 16.9581 31.9795 17.0726C31.9852 16.958 31.9894 16.8432 31.9926 16.728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9847 15.5702H13.325L3.74024 5.98682C3.43043 6.31357 3.09462 6.76981 2.88693 7.09475L12.0531 16.2657L2.87924 25.4398C3.06087 25.7629 3.45655 26.2412 3.73437 26.5523L13.3252 16.9615H31.9869C31.9969 16.7307 32 16.499 32 16.2659C31.9999 15.9535 31.9913 15.7232 31.9847 15.5702Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88669 19.6822V18.342C5.22406 18.342 6.312 17.254 6.312 15.9167C6.312 14.9705 5.54219 14.2008 4.59606 14.2008C3.9515 14.2008 3.42706 14.7251 3.42706 15.3698C3.42706 15.782 3.76238 16.1174 4.17462 16.1174C4.40762 16.1174 4.59719 15.9277 4.59719 15.6947H5.93731C5.93731 16.6668 5.14656 17.4575 4.17469 17.4575C3.0235 17.4576 2.08707 16.521 2.08707 15.37C2.08707 13.9864 3.21269 12.8608 4.59612 12.8608C6.28125 12.8608 7.65224 14.2318 7.65224 15.9169C7.65218 17.993 5.963 19.6822 3.88669 19.6822Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVanuatu);
export default __webpack_public_path__ + "static/media/flag_vanuatu.93ec7c12576196380b00391ae7076e90.svg";
export { ForwardRef as ReactComponent };